import { Collapsible as C } from 'radix-ui';

const Collapsible = C.Root;
const CollapsibleTrigger = C.Trigger;
const CollapsibleContent = C.Content;

export { Collapsible, CollapsibleContent, CollapsibleTrigger };
